import Component from './person-form';
export default Component;
